import { flow } from 'fp-ts/lib/function';
import { chainW } from 'fp-ts/lib/TaskEither';

import { useTRPC } from '../../../hooks/useTRPC';
import { enhancedErrorHandler } from '../../../lib/enhancedErrorHandler';
import * as Form from '../../Form';

import { FormData } from './FormData';

interface Props {
  className?: string;
  onComplete?(formData: FormData): void;
  initialFormData?: FormData;
}

export function CreateOrganization(props: Props) {
  const trpc = useTRPC();

  return (
    <Form.Root
      key={props.initialFormData ? 'with-data' : 'empty'}
      className={props.className}
      formDataShape={FormData}
      validityKey={props.initialFormData ? 'check-validity' : undefined}
      onComplete={props.onComplete}
      onSubmitData={flow(
        chainW(
          (formData) => () =>
            trpc.createPublisherOrganization
              .mutate(formData)
              .catch(enhancedErrorHandler),
        ),
      )}
    >
      <div className="space-y-6">
        <Form.Input
          required
          label="Publisher Name"
          name="publisherName"
          defaultValue={props.initialFormData?.publisherName}
        />
        <Form.UrlInput
          required
          label="Website"
          name="website"
          placeholder="https://"
          defaultValue={props.initialFormData?.website}
        />
        <Form.FileInput
          label="Publisher Avatar (Optional)"
          maxSize={3000000}
          name="avatar"
        />
      </div>
      <div className="my-16 w-full">
        <Form.Submit className="w-full">Next</Form.Submit>
        <Form.Error className="mt-1" />
      </div>
    </Form.Root>
  );
}
